// extracted by mini-css-extract-plugin
export default {"instructions":"ParcelEstimatedInstructions_instructions__fR+83"};